var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.statusColor,"dark":_vm.dark}},[_c('v-icon',[_vm._v("mdi-label-outline")]),_vm._v(" "+_vm._s(_vm.statusText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }